import React, { useState } from 'react';

const FORM_URL = 'https://docs.google.com/forms/u/3/d/e/1FAIpQLSfwq0VgQMIA37xz4zXaiCcnC8_e85sqlwFHSjyjBbjqz4p56w/formResponse';

const FIELDS = {
    name: 'entry.587616666',
    email: 'entry.767123490',
    phone: 'entry.1754416317',
    message: 'entry.1400819155',
};

const Result = () => {
    return (
        <p className="success-message">Praise God! Someone from our church will be in touch with you soon.</p>
    )
}

function SalvationForm() {
    const [result, showResult] = useState(false);
    const [formData, setFormData] = useState({
        [FIELDS.name]: '',
        [FIELDS.email]: '',
        [FIELDS.phone]: '',
        [FIELDS.message]: '',
    });

    const handleChange = (field) => (e) => {
        const { value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await fetch(FORM_URL, {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData),
            });
        } catch (error) {
            console.error('Failed to submit salvation decision:', error);
        }

        e.target.reset();
        setFormData({
            [FIELDS.name]: '',
            [FIELDS.email]: '',
            [FIELDS.phone]: '',
            [FIELDS.message]: '',
        });
        showResult(true);
        setTimeout(() => {
            showResult(false);
        }, 5000);
    };

    return (
        <div className="form-wrapper rn-form-box">
            <form onSubmit={handleSubmit} className="contact-form--1">
                <div className="row">
                    <div className="col-12 col-md-6 mb-0 mb-md-0">
                        <div className="rn-form-group">
                            <input
                                type="text"
                                name={FIELDS.name}
                                placeholder="Your Name"
                                value={formData[FIELDS.name]}
                                onChange={handleChange(FIELDS.name)}
                                required
                            />
                        </div>

                        <div className="rn-form-group">
                            <input
                                type="email"
                                name={FIELDS.email}
                                placeholder="Your Email"
                                value={formData[FIELDS.email]}
                                onChange={handleChange(FIELDS.email)}
                                required
                            />
                        </div>

                        <div className="rn-form-group">
                            <input
                                type="text"
                                name={FIELDS.phone}
                                placeholder="Phone Number (optional)"
                                value={formData[FIELDS.phone]}
                                onChange={handleChange(FIELDS.phone)}
                            />
                        </div>
                    </div>

                    <div className="col-12 col-md-6 d-flex flex-column">
                        <div className="rn-form-group flex-grow-1 d-flex flex-column">
                            <textarea
                                name={FIELDS.message}
                                placeholder="Tell Us More (optional)"
                                value={formData[FIELDS.message]}
                                onChange={handleChange(FIELDS.message)}
                            ></textarea>
                        </div>

                        <div className="rn-form-group">
                            <button className="btn-default btn-border btn-opacity" type="submit">
                                <span>Submit</span>
                            </button>
                        </div>

                        <div className="rn-form-group">
                            {result ? <Result /> : null}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default SalvationForm;
